// extracted by mini-css-extract-plugin
module.exports = {"explicitBadge":"channelpage_explicitBadge__PqV0I"};